/* eslint eqeqeq: "off" */
export default ([arg1, arg2]) => arg1 == arg2;
